import { Component } from '@angular/core';
import { AuthService } from '@app/services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {
  isNavbarCollapsed = false;

  constructor(private authService: AuthService, private router: Router) {
  }

  async logout() {
    await this.authService.signOutUser();
  }

  get getUserName() {
    return this.getFullName();
  }

  getFullName() {
    if (this.authService.getFullName && this.authService.getFullName.trim()) {
      return this.authService.getFullName;
    }
    return this.authService.userClaims.name;
  }

  get getInitials() {
    const nameParts = this.getFullName().split(' ');
    const initials = nameParts.map((part: any) => part.charAt(0).toUpperCase()).join('');
    return initials;
  }

  get isLoggedIn() {
    return this.authService.isLoggedIn;
  }
}
